import { render, staticRenderFns } from "./dbIcon.vue?vue&type=template&id=792c11e6&scoped=true&"
import script from "./dbIcon.vue?vue&type=script&lang=js&"
export * from "./dbIcon.vue?vue&type=script&lang=js&"
import style0 from "./dbIcon.vue?vue&type=style&index=0&id=792c11e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c11e6",
  null
  
)

export default component.exports